var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFireworks = function SvgIconFireworks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F590BE"
    },
    d: "M456.134,272.216c-4.262,0-7.715-3.454-7.715-7.715v-16.972c0-4.261,3.453-7.715,7.715-7.715 c4.262,0,7.715,3.454,7.715,7.715v16.972C463.849,268.763,460.395,272.216,456.134,272.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F590BE"
    },
    d: "M456.134,326.219c-4.262,0-7.715-3.454-7.715-7.715v-16.972c0-4.261,3.453-7.715,7.715-7.715 c4.262,0,7.715,3.454,7.715,7.715v16.972C463.849,322.765,460.395,326.219,456.134,326.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F590BE"
    },
    d: "M491.622,290.732h-16.973c-4.262,0-7.715-3.454-7.715-7.715c0-4.261,3.453-7.715,7.715-7.715h16.973 c4.262,0,7.715,3.454,7.715,7.715C499.337,287.278,495.884,290.732,491.622,290.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F590BE"
    },
    d: "M437.619,290.732h-16.972c-4.262,0-7.715-3.454-7.715-7.715c0-4.261,3.453-7.715,7.715-7.715h16.972 c4.262,0,7.715,3.454,7.715,7.715C445.334,287.278,441.88,290.732,437.619,290.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF2E61"
    },
    d: "M61.146,386.393c-4.262,0-7.715-3.454-7.715-7.715v-16.972c0-4.261,3.453-7.715,7.715-7.715 s7.715,3.454,7.715,7.715v16.972C68.861,382.938,65.408,386.393,61.146,386.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF2E61"
    },
    d: "M61.146,440.396c-4.262,0-7.715-3.454-7.715-7.715v-16.973c0-4.261,3.453-7.715,7.715-7.715 s7.715,3.454,7.715,7.715v16.973C68.861,436.941,65.408,440.396,61.146,440.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF2E61"
    },
    d: "M96.633,404.908H79.661c-4.262,0-7.715-3.454-7.715-7.715s3.453-7.715,7.715-7.715h16.972 c4.262,0,7.715,3.454,7.715,7.715S100.895,404.908,96.633,404.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF2E61"
    },
    d: "M42.631,404.908H25.659c-4.262,0-7.715-3.454-7.715-7.715s3.453-7.715,7.715-7.715h16.972 c4.262,0,7.715,3.454,7.715,7.715S46.893,404.908,42.631,404.908z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0DAACE"
    },
    d: "M386.705,374.049c-3.367,0-6.401-2.258-7.385-5.476c-0.978-3.2,0.304-6.801,3.095-8.648 c5.723-3.79,13.485,1.546,11.766,8.285C393.318,371.595,390.209,374.049,386.705,374.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0DAACE"
    },
    d: "M274.066,173.469c-6.934,0-10.327-8.869-5.123-13.479c2.604-2.306,6.52-2.568,9.412-0.645 c2.588,1.721,3.904,4.952,3.259,7.992C280.866,170.863,277.681,173.469,274.066,173.469z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDC65"
    },
    d: "M102.66,289.194c-6.857,0-10.277-8.709-5.237-13.385c2.434-2.258,6.153-2.673,9.036-1.043 c2.832,1.602,4.389,4.937,3.778,8.138C109.553,286.49,106.326,289.194,102.66,289.194z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0DAACE"
    },
    points: "63.148,80.668 81.432,117.717 122.319,123.659 92.733,152.498 99.718,193.218  63.148,173.993 26.579,193.218 33.562,152.498 3.977,123.659 44.863,117.717 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDDC65"
    },
    points: "448.852,80.668 467.137,117.717 508.023,123.659 478.438,152.498 485.422,193.218  448.852,173.993 412.282,193.218 419.267,152.498 389.681,123.659 430.568,117.717 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F590BE"
    },
    points: "182.133,0 200.417,37.049 241.303,42.99 211.718,71.829 218.703,112.55 182.133,93.325  145.562,112.55 152.547,71.829 122.962,42.99 163.848,37.049 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF2E61"
    },
    points: "329.867,0 348.152,37.049 389.038,42.99 359.453,71.829 366.438,112.55 329.867,93.325  293.297,112.55 300.282,71.829 270.697,42.99 311.583,37.049 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F590BE"
    },
    d: "M237.908,512c-4.262,0-7.715-3.454-7.715-7.715V378.678c0-122.289-52.584-223.752-53.116-224.764 c-1.983-3.772-0.533-8.436,3.239-10.418c3.769-1.983,8.436-0.533,10.418,3.239c0.564,1.072,13.959,26.741,27.507,68.27 c12.491,38.293,27.381,97.773,27.381,163.671v125.607C245.623,508.546,242.17,512,237.908,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF2E61"
    },
    d: "M274.092,512c-4.262,0-7.715-3.454-7.715-7.715V378.678c0-65.898,14.891-125.378,27.381-163.671 c13.548-41.529,26.943-67.198,27.507-68.27c1.983-3.772,6.649-5.222,10.418-3.239c3.772,1.982,5.223,6.646,3.239,10.418 c-0.607,1.158-53.116,102.736-53.116,224.764v125.607C281.807,508.546,278.354,512,274.092,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDDC65"
    },
    d: "M306.491,445.024c-4.262,0-7.715-3.454-7.715-7.715c0-72.573,22.335-128.397,41.072-162.447 c20.389-37.054,40.674-56.76,41.528-57.581c3.072-2.952,7.955-2.857,10.908,0.214c2.951,3.07,2.858,7.949-0.208,10.903l0,0 c-0.194,0.188-19.743,19.265-39.014,54.457c-17.726,32.372-38.856,85.445-38.856,154.454 C314.206,441.569,310.753,445.024,306.491,445.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0DAACE"
    },
    d: "M205.508,445.024c-4.262,0-7.715-3.454-7.715-7.715c0-69.009-21.13-122.083-38.856-154.454 c-19.27-35.192-38.819-54.268-39.014-54.457c-3.063-2.957-3.153-7.84-0.199-10.906c2.955-3.065,7.831-3.16,10.9-0.211 c0.854,0.821,21.139,20.526,41.528,57.581c18.736,34.051,41.072,89.874,41.072,162.447 C213.223,441.569,209.77,445.024,205.508,445.024z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFireworks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-fireworks.309e21ed.svg";
export { ForwardRef as ReactComponent };